import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { GraphMeasure } from '../../../../../../types/graph-data.interface';
import { CesButtonSecondaryComponent } from '../../../../../ui/ces-buttons/ces-button-secondary.component';
import { GraphItemRowComponent } from './graph-item-row.component';

@Component({
  selector: 'app-measure-selector-ev-temp',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslocoModule, CesButtonSecondaryComponent, GraphItemRowComponent],
  templateUrl: './measure-selector-ev-temp.component.html',
})
export class MeasureSelectorEvTempComponent {
  readonly selectedMeasures = input.required<GraphMeasure[]>();

  // UAT 27.07 #29 : la liste se LIT par ordre alphabétique ; l'ordre du
  // tableau d'entrée reste intact — il porte l'ordre des traces et de la
  // légende, et sort_nr persiste l'affectation des axes.
  readonly sortedMeasures = computed(() => [...this.selectedMeasures()].sort((a, b) => a.name.localeCompare(b.name)));

  readonly selectMeasures = output<void>();
  readonly configureMeasure = output<GraphMeasure>();
  readonly removeMeasure = output<GraphMeasure>();
}
